import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt="Alpielec Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-slate-400 mb-4">
              Expert en travaux d'électricité et cordiste professionnel au Pays Basque
            </p>
            <div className="flex flex-col gap-2">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 text-sm hover:text-blue-400 transition-colors">
                <Phone className="w-4 h-4" />
                {companyInfo.phone}
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 text-sm hover:text-blue-400 transition-colors">
                <Mail className="w-4 h-4" />
                {companyInfo.email}
              </a>
            </div>
          </div>

          {/* Services Électricien */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services Électricien</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/electricien#conformite" className="text-sm hover:text-blue-400 transition-colors">
                  Remises en Conformité
                </Link>
              </li>
              <li>
                <Link to="/electricien#depannage" className="text-sm hover:text-blue-400 transition-colors">
                  Dépannages
                </Link>
              </li>
              <li>
                <Link to="/electricien#renovation" className="text-sm hover:text-blue-400 transition-colors">
                  Rénovations
                </Link>
              </li>
              <li>
                <Link to="/electricien#travaux-neufs" className="text-sm hover:text-blue-400 transition-colors">
                  Travaux Neufs
                </Link>
              </li>
            </ul>
          </div>

          {/* Services Cordiste */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services Cordiste</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/cordiste#haute-tension" className="text-sm hover:text-blue-400 transition-colors">
                  Travaux Haute Tension
                </Link>
              </li>
              <li>
                <Link to="/cordiste#relamping" className="text-sm hover:text-blue-400 transition-colors">
                  Relamping
                </Link>
              </li>
              <li>
                <Link to="/cordiste#maconnerie" className="text-sm hover:text-blue-400 transition-colors">
                  Reprise de Maçonnerie
                </Link>
              </li>
              <li>
                <Link to="/cordiste#port-charge" className="text-sm hover:text-blue-400 transition-colors">
                  Port de Charge
                </Link>
              </li>
              <li>
                <Link to="/cordiste#petits-travaux" className="text-sm hover:text-blue-400 transition-colors">
                  Petits Travaux en Hauteur
                </Link>
              </li>
            </ul>
          </div>

          {/* Zone d'intervention */}
          <div>
            <h3 className="text-white font-semibold mb-4">Zone d'Intervention</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="font-medium text-white">Pays Basque</p>
                  <p className="text-slate-400">Basé à Urrugne</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Clock className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="text-slate-400">Disponible 7j/7</p>
                  <p className="text-slate-400">pour dépannages</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {currentYear} Alpielec. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <Link to="/contact" className="text-sm hover:text-blue-400 transition-colors">
                Mentions légales
              </Link>
              <Link to="/contact" className="text-sm hover:text-blue-400 transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
